import styled, { keyframes, css } from 'styled-components';

const TEAL = '#2B4E56';
const TEXT_DIM = '#7A8C92';
const BG_ACTIVE = '#F7F2F0';

const overlayIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const panelIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1300;
  background: rgba(15, 30, 35, 0.42);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 110px;
  animation: ${overlayIn} 120ms ease;
`;

export const Panel = styled.div`
  width: 480px;
  max-width: calc(100vw - 32px);
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0 24px 48px rgba(15, 30, 35, 0.35), 0 4px 8px rgba(15, 30, 35, 0.12);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: ${panelIn} 140ms ease;
`;

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-bottom: 1px solid #efe7e3;
`;

export const SearchIconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${TEXT_DIM};
`;

export const SearchInput = styled.input`
  flex: 1;
  border: 0;
  background: transparent;
  font: inherit;
  font-size: 14px;
  color: ${TEAL};
  outline: none;

  &::placeholder {
    color: ${TEXT_DIM};
  }
`;

export const EscChip = styled.span`
  padding: 2px 6px;
  background: #f1ebe8;
  border-radius: 3px;
  color: ${TEAL};
  font-size: 11px;
  font-weight: 600;
`;

export const Results = styled.div`
  margin: 0;
  padding: 4px 0;
  max-height: 320px;
  overflow-y: auto;
`;

/* Rendered as a <Link> for results that point at a route (see index.js), so right-click "Open link in
   new tab/window", middle-click and cmd/ctrl-click all work. Quick actions have no path and stay a
   plain row. */
export const Result = styled.a`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  cursor: pointer;
  color: ${TEAL};
  text-decoration: none;

  ${({ $active }) =>
    $active &&
    css`
      background: ${BG_ACTIVE};
    `}
`;

export const ResultIcon = styled.span`
  width: 22px;
  height: 22px;
  border-radius: 4px;
  background: #f1ebe8;
  color: ${TEAL};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const ResultText = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ResultLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: capitalize;
`;

export const ResultSubtitle = styled.div`
  font-size: 11px;
  color: ${TEXT_DIM};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const OpenPill = styled.span`
  padding: 2px 8px;
  border-radius: 10px;
  background: #f1ebe8;
  color: ${TEAL};
  font-size: 11px;
  font-weight: 600;
  flex-shrink: 0;
`;

export const EmptyState = styled.div`
  padding: 24px 12px;
  text-align: center;
  color: ${TEXT_DIM};
  font-size: 13px;
`;

export const FooterHints = styled.div`
  display: flex;
  gap: 12px;
  padding: 8px 12px;
  border-top: 1px solid #efe7e3;
  color: ${TEXT_DIM};
  font-size: 11px;
  background: #fbf8f6;
`;

export const Hint = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const Kbd = styled.kbd`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  background: #f1ebe8;
  border-radius: 3px;
  color: ${TEAL};
  font-size: 10px;
  font-family: inherit;
`;
